export default __webpack_public_path__ + "static/media/caen13.a7d011c9.jpg";